<template>
  <div id="staffTermlyReportList">
    <!-- Web -->
    <div class="container" style="text-align: left; width: 80%" v-if="!checkMobileStatus">
      <label style="color: #536170; font-size: 22px">
        <i class="fa fa-clipboard"></i>
        {{ lang('Published Report') }}</label
      >

      <div>
        <div class="row" style="margin: 25px 0px; display: none">
          <div :class="userType !== 'Parent' ? 'staff-search' : 'parent-search'" style="position: relative">
            <img src="../assets/Vector-search.png" style="position: absolute; top: 10px; left: 10px" />
            <input type="text" placeholder="Search Report" class="search-report" />
            <button class="btn-search">{{ lang('Search') }}</button>
          </div>

          <div style="width: 15%; margin-left: auto; text-align: right" v-if="userType !== 'Parent'">
            <button class="btn-view-by-list" @click="changeView()">
              <i class="fa fa-list-ul" aria-hidden="true" style="margin-right: 10px"></i>
              {{ !isList ? lang('View By List') : lang('View By Post') }}
            </button>
          </div>
        </div>

        <div v-if="termlyReportList.length > 0">
          <div v-if="!isList">
            <div class="tprl-container" v-for="trList in termlyReportList">
              <div class="row" style="margin: 0px">
                <div style="width: 70%">
                  <label style="color: #333333; font-size: 14px; margin-bottom: 0px">{{ trList.PublisherName }}</label>
                  <span style="color: #9e9e9e; display: block; font-size: 12px">{{ trList.TermlyRepprtPublishDate }}</span>
                </div>

                <div style="width: 25%; margin-left: auto; text-align: right">
                  <!-- margin-right: 10px;-->
                  <span class="tprl-span-download" style="" @click="singleDownload(trList)">
                    <i class="fa fa-download" aria-hidden="true" style="margin: 7px 0px"></i>
                  </span>

                  <!--                                    <span class="tprl-span-enlarge">-->
                  <!--                                        <i class="fa fa-arrows-alt" aria-hidden="true" style="margin: 7px 0px;"></i>-->
                  <!--                                    </span>-->
                </div>
              </div>

              <div style="margin-top: 20px">
                <div class="row" style="margin: 0px">
                  <div class="tprl-left-container">
                    <div class="tprl-pdf-page" @click="trList.activePage = index + 1" v-for="(a, index) in trList.numPages">
                      <pdf
                        class="pdf-page"
                        :class="trList.activePage === index + 1 ? 'active' : ''"
                        style="display: block; width: 100%"
                        :src="trList.TermlyRepprtPublishFilePath"
                        :page="index + 1"
                      >
                      </pdf>

                      <span>{{ index + 1 }}</span>
                    </div>
                  </div>

                  <div class="tprl-right-container">
                    <div class="tprl-pdf-page-preview">
                      <pdf style="display: block; width: 100%" :src="trList.TermlyRepprtPublishFilePath" :page="trList.activePage"> </pdf>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="tprl-container" v-if="isList">
            <div>
              <span style="font-size: 16px; display: block; color: #536170">{{ lang('Published Report') }} {{ lang('List') }}</span>

              <div class="tprl-list-container">
                <table>
                  <tr>
                    <th>Title</th>
                    <th>Date</th>
                    <th></th>
                  </tr>
                  <tr>
                    <td>Alfreds Futterkiste</td>
                    <td>Maria Anders</td>
                    <td style="text-align: right">
                      <button class="btn-download" @click="singleDownload()">{{ lang('Download') }}</button>
                      <button class="btn-view">{{ lang('View') }}</button>
                    </td>
                  </tr>
                  <tr>
                    <td>Centro comercial Moctezuma</td>
                    <td>Francisco Chang</td>
                    <td style="text-align: right">
                      <button class="btn-download">{{ lang('Download') }}</button>
                      <button class="btn-view">{{ lang('View') }}</button>
                    </td>
                  </tr>
                  <tr>
                    <td>Ernst Handel</td>
                    <td>Roland Mendel</td>
                    <td style="text-align: right">
                      <button class="btn-download">{{ lang('Download') }}</button>
                      <button class="btn-view">{{ lang('View') }}</button>
                    </td>
                  </tr>
                  <tr>
                    <td>Island Trading</td>
                    <td>Helen Bennett</td>
                    <td style="text-align: right">
                      <button class="btn-download">{{ lang('Download') }}</button>
                      <button class="btn-view">{{ lang('View') }}</button>
                    </td>
                  </tr>
                  <tr>
                    <td>Laughing Bacchus Winecellars</td>
                    <td>Yoshi Tannamuri</td>
                    <td style="text-align: right">
                      <button class="btn-download">{{ lang('Download') }}</button>
                      <button class="btn-view">{{ lang('View') }}</button>
                    </td>
                  </tr>
                  <tr>
                    <td>Magazzini Alimentari Riuniti</td>
                    <td>Giovanni Rovelli</td>
                    <td style="text-align: right">
                      <button class="btn-download">{{ lang('Download') }}</button>
                      <button class="btn-view">{{ lang('View') }}</button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="empty-list_image" v-if="termlyReportList.length <= 0">
          <strong>Empty List!</strong>
          <img src="../assets/notfound.png" />
        </div>

        <div class="lds-ellipsis" v-if="isLoad">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
    <!-- End Web -->

    <!-- Mobile -->
    <div v-if="checkMobileStatus">
      <h1>HI Mobile</h1>

      <div>
        <div v-if="termlyReportList.length > 0"></div>

        <div class="empty-list_image" v-if="termlyReportList.length <= 0">
          <strong>Empty List!</strong>
          <img src="../assets/notfound.png" />
        </div>
      </div>
    </div>
    <!-- EndMobile -->
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import Cookies from 'js-cookie'
import $ from 'jquery'
import { lang } from '../locale/index'
import moment from 'moment'
import pdf from 'vue-pdf'

export default {
  name: 'StaffTermlyReportList',
  components: {
    pdf,
  },
  props: [],
  data() {
    return {
      userType: '',
      checkMobileStatus: false,
      termlyReportList: [],
      isList: false,
      numberOfTermlyReport: '3',
      lastTermlyReportID: '',
      mode: 'Self',

      currentPage: 1,
      currentPdfPath: '',
      isLoad: false,
    }
  },
  async created() {
    this.userType = Cookies.get('userTypeSession')
    // this.sessionID = Cookies.get('userIDSession');
    // this.schID = Cookies.get('schoolSession');

    await this.getTermlyReportPublishList()

    window.addEventListener('resize', this.isMobile)
  },
  async mounted() {
    this.isMobile()

    const self = this

    /*#region Scroll Loader Functions*/
    $(window).scroll(
      self.debounce(() => {
        if (self.getScrollPercent() >= 80 && self.termlyReportList.length % 3 === 0 && self.termlyReportList.length !== 0 && !self.isLoad) {
          self.isLoad = true

          let obj_LastPost = !self.isNull(self.termlyReportList) ? self.termlyReportList[self.termlyReportList.length - 1] : ''
          let promise_GetPosts = DataSource.shared.getPublishedTermlyReport(self.numberOfTermlyReport, obj_LastPost.TermlyReportID, self.mode)

          promise_GetPosts.then(response => {
            if (response.Table) {
              response.Table.forEach(file => {
                file.numPages = undefined

                if (file.TermlyRepprtPublishFilePath) {
                  let src = pdf.createLoadingTask(file.TermlyRepprtPublishFilePath)
                  file.pageOfSrc = src
                  src.promise.then(pdf => {
                    file.numPages = pdf.numPages
                  })
                }
                file.activePage = 1
              })

              self.termlyReportList.push.apply(self.termlyReportList, response.Table)
            }
            self.isLoad = false
          })
        }
      }, 250),
    )
    /*#endregion*/
  },
  methods: {
    lang,

    sleep(milliseconds) {
      return new Promise(resolve => setTimeout(resolve, milliseconds))
    },

    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0 || obj === ''
    },

    isMobile() {
      let screenWidth = window.innerWidth
      if (screenWidth <= 770) {
        this.checkMobileStatus = true
      } else {
        this.checkMobileStatus = false
      }
    },

    async getTermlyReportPublishList() {
      this.termlyReportList = []
      this.$vs.loading()
      this.isLoad = true

      try {
        const response = await DataSource.shared.getPublishedTermlyReport(this.numberOfTermlyReport, this.lastTermlyReportID, this.mode)

        if (response.code === '88') {
          console.log('Cannot get Summative Report! code 88')
        } else if (response.code === '99') {
          console.log('Cannot get Summative Report! code 99')
        } else if (response.code === '2') {
          console.log('Empty list!')
        } else {
          response.Table.forEach(resp => {
            resp.numPages = undefined

            if (resp.TermlyRepprtPublishFilePath) {
              let src = pdf.createLoadingTask(resp.TermlyRepprtPublishFilePath)
              resp.pageOfSrc = src
              src.promise.then(pdf => {
                resp.numPages = pdf.numPages
              })
            }
            resp.activePage = 1
          })

          this.termlyReportList = response.Table
        }

        // console.log(this.termlyReportList, "list");
      } catch (e) {
        console.log(e)
      }

      await this.sleep(300)
      this.$vs.loading.close()
      this.isLoad = false
    },

    changeView() {
      if (this.isList) {
        this.isList = false
      } else {
        this.isList = true
      }
    },

    changePdfPage(pdfPath, index) {
      this.currentPage = index + 1
    },

    singleDownload(singlePdf) {
      try {
        // this.$vs.loading();

        let a = document.createElement('a')
        // let contentType = "application/pdf";
        // let b64Data = singlePdf.TermlyRepprtPublishFilePath;
        // let blob = this.b64toBlob(b64Data, contentType);

        a.href = singlePdf.TermlyRepprtPublishFilePath
        // a.download = (singlePdf.TermlyReportID + ".pdf").toString();
        a.target = '_blank'
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        a.remove()

        // this.$vs.loading.close();
      } catch (e) {
        this.results = e
      }
    },

    b64toBlob(b64Data, contentType, sliceSize) {
      //Credit to Jeremy Banks @ stackoverflow
      contentType = contentType || ''
      sliceSize = sliceSize || 512

      let byteCharacters = atob(b64Data)
      let byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize)

        let byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        let byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      return new Blob(byteArrays, { type: contentType })
    },

    /*#region Scroll Loader Functions*/
    getScrollPercent() {
      //Credits to Phil Ricketts @ stackoverflow
      let height = document.documentElement,
        body = document.body,
        scrollTop = 'scrollTop',
        scrollHeight = 'scrollHeight'

      return ((height[scrollTop] || body[scrollTop]) / ((height[scrollHeight] || body[scrollHeight]) - height.clientHeight)) * 100
    },
    isScrollable() {
      return $(document).height() > $(window).height()
    },
    debounce(func, wait, immediate) {
      // Returns a function, that, as long as it continues to be invoked, will not
      // be triggered. The function will be called after it stops being called for
      // N milliseconds. If `immediate` is passed, trigger the function on the
      // leading edge, instead of the trailing.
      let timeout, result
      let self = this

      let later = function (context, args) {
        timeout = null
        if (args) result = func.apply(context, args)
      }

      let debounced = self.restArguments(function (args) {
        if (timeout) clearTimeout(timeout)
        if (immediate) {
          let callNow = !timeout
          timeout = setTimeout(later, wait)
          if (callNow) result = func.apply(this, args)
        } else {
          timeout = self.delay(later, wait, this, args)
        }

        return result
      })

      debounced.cancel = function () {
        clearTimeout(timeout)
        timeout = null
      }

      return debounced
    },
    delay(func, wait, ...args) {
      // Lodash Delay
      /**
       * Invokes `func` after `wait` milliseconds. Any additional arguments are
       * provided to `func` when it's invoked.
       *
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to delay.
       * @param {number} wait The number of milliseconds to delay invocation.
       * @param {...*} [args] The arguments to invoke `func` with.
       * @returns {number} Returns the timer id.
       * @example
       *
       * delay(text => console.log(text), 1000, 'later')
       * // => Logs 'later' after one second.
       */
      if (typeof func != 'function') {
        throw new TypeError('Expected a function')
      }
      return setTimeout(func, +wait || 0, ...args)
    },
    restArguments(func, startIndex) {
      // Some functions take a variable number of arguments, or a few expected
      // arguments at the beginning and then a variable number of values to operate
      // on. This helper accumulates all remaining arguments past the function?s
      // argument length (or an explicit `startIndex`), into an array that becomes
      // the last argument. Similar to ES6?s "rest parameter".
      startIndex = startIndex == null ? func.length - 1 : +startIndex
      return function () {
        let length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0
        for (; index < length; index++) {
          rest[index] = arguments[index + startIndex]
        }
        switch (startIndex) {
          case 0:
            return func.call(this, rest)
          case 1:
            return func.call(this, arguments[0], rest)
          case 2:
            return func.call(this, arguments[0], arguments[1], rest)
        }
        let args = Array(startIndex + 1)
        for (index = 0; index < startIndex; index++) {
          args[index] = arguments[index]
        }
        args[startIndex] = rest
        return func.apply(this, args)
      }
    },
    /*#endregion*/
  },
  destroyed() {
    window.removeEventListener('resize', this.isMobile)
  },
  watch: {},
}
</script>

<style scoped>
.staff-search {
  width: 85%;
}

.parent-search {
  width: 100%;
}

.search-report {
  padding: 8px 15px 8px 35px;
  font-size: 14px;
  border: none;
  /*float: left;*/
  width: 80%;
  background: #ffffff;
  border-radius: 6px 0px 0px 6px;
}

.btn-search {
  width: 20%;
  padding: 8px 15px;
  background: #2196f3;
  color: white;
  font-size: 14px;
  cursor: pointer;
  border: none;
  border-radius: 0px 6px 6px 0px;
}

.btn-search:focus {
  /*outline: none;*/
}

.btn-view-by-list {
  background: #91a3b6;
  border-radius: 5px;
  padding: 8px 15px 8px 15px;
  color: #ffffff;
  border: none;
}

.tprl-container {
  background: #ffffff;
  padding: 20px;
  border-radius: 6px;
  margin-bottom: 20px;
}

.tprl-span-download,
.tprl-span-enlarge {
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #e1e6f0;
  text-align: center;
  cursor: pointer;
}

.tprl-left-container {
  width: 15%;
  /*max-height: 100vh;*/
  max-height: 1200px;
  overflow: auto;
  padding-right: 10px;
}

.tprl-pdf-page {
  width: 100%;
  /*height: 175px;*/
  text-align: center;
}

.tprl-pdf-page .pdf-page {
  border: 1px solid rgba(210, 210, 210, 0.49);
  width: 100%;
  /*height: 150px;*/
  /*max-height: 150px;*/
  cursor: pointer;
}

.tprl-pdf-page .pdf-page.active {
  border: 2px solid #426dff;
}

.tprl-right-container {
  width: 82%;
  margin-left: auto;
}

.tprl-pdf-page-preview {
  border: 1px solid #d2d2d2;
  height: 100%;
  width: 100%;
}

.tprl-list-container {
  margin-top: 20px;
}

.tprl-list-container table {
  border-collapse: collapse;
  width: 100%;
}

.tprl-list-container th {
  color: #91a3b6;
  font-weight: normal;
  font-size: 14px;
}

.tprl-list-container td {
  color: #5f5f5f;
  font-size: 14px;
  font-weight: normal;
}

.tprl-list-container td,
.tprl-list-container th {
  /*border: 1px solid #dddddd;*/
  text-align: left;
  padding: 8px;
}

.tprl-list-container tr:nth-child(even) {
  background-color: #f1f4fc;
}

.btn-download {
  background: #91a3b6;
  border-radius: 5px;
  padding: 5px 10px;
  color: #ffffff;
  border: none;
  margin-right: 15px;
}

.btn-view {
  background: #426dff;
  border-radius: 5px;
  padding: 5px 10px;
  color: #ffffff;
  border: none;
}

.tprl-left-container::-webkit-scrollbar {
  background-color: #fff;
  width: 6px;
}

.tprl-left-container::-webkit-scrollbar-thumb {
  background-color: #426dff;
}

.tprl-left-container::-webkit-scrollbar-track {
  background-color: #ffffff;
}
</style>
